import { useState } from 'react'
import PropTypes from 'prop-types'
import { savePhoto } from 'registry/api'
import Spinner from 'shared/spinner'
import { REGISTRY_PROFILE_IMG_TRANSFORM } from 'shared/constants'

import css from './photo-uploader.scss'
import RegistryAvatar from '../../../../components/registry-avatar'

export const UploadPhotoPreview = ({ photo, uploading }) => {
  return (
    <div className={css.uploadPhotoContainer}>
      {photo ? (
        <RegistryAvatar editable url={photo} />
      ) : uploading ? (
        <div className={css.uploadSpinnerContainer}>
          <Spinner className="center-xy" />
        </div>
      ) : (
        <RegistryAvatar editable url={photo} />
      )}
    </div>
  )
}

UploadPhotoPreview.propTypes = {
  photo: PropTypes.string,
  uploading: PropTypes.bool,
}

const PhotoUploader = ({ onChange, value = '', label, className }) => {
  const [loading, setLoading] = useState(false)
  const [photoUrl, setPhotoUrl] = useState(value)
  let fileComponent

  const _handleFileInputChange = (event) => {
    const reader = new FileReader()
    const image = event.target.files[0]

    reader.onload = _readLocalImage

    if (image instanceof Blob) {
      reader.readAsDataURL(image)
    }
  }

  const _readLocalImage = (event) => {
    setLoading(true)
    savePhoto(event.target.result)
      .then((resp) =>
        resp.secure_url.replace(
          'upload',
          `upload/${REGISTRY_PROFILE_IMG_TRANSFORM}`
        )
      )
      .then((resp) => {
        setPhotoUrl(resp)
        setLoading(false)
        onChange(resp)
      })
      .catch((err) => onChange(err))
  }

  return (
    <div className={className}>
      <div className="control-label mbm">{label}</div>

      <div className={css.photoWrapper}>
        <div className={css.uploadPhotoContainer}>
          <UploadPhotoPreview photo={photoUrl} uploading={loading} />
          <input
            accept="image/*"
            className={css.fileUploader}
            id="fileUploadInput"
            type="file"
            onChange={_handleFileInputChange}
          />
        </div>
      </div>
    </div>
  )
}

PhotoUploader.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

export default PhotoUploader
